module.exports = __webpack_public_path__ + "img/completionRate.72bcf054.png";